var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var InputButton = /** @class */ (function () {
            function InputButton() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmClick: '@',
                    qmColor: '@',
                    qmIcon: '@',
                    qmTooltip: '@',
                    qmHref: '@',
                    qmStyle: '@'
                };
                this.templateUrl = 'Input/Button';
            }
            InputButton = __decorate([
                QMC.Directive('QMC.Input', 'qmInputButton', [])
            ], InputButton);
            return InputButton;
        }());
        Input.InputButton = InputButton;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputCheckbox = /** @class */ (function () {
            function qmInputCheckbox() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmId: '@',
                    qmChange: '@',
                    qmTooltip: '@',
                    qmColor: '@',
                    qmLabelLeft: '@',
                    qmDisabled: '='
                };
                this.templateUrl = 'Input/Checkbox';
                this.link = function (scope, element, attrs) {
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    var lastState = !scope.qmModel;
                    scope.dependedToggle = function () {
                        if (scope.qmDisabled)
                            return;
                        if (!scope.qmLabel || scope.qmLabel.length == 0)
                            return;
                        if (lastState == scope.qmModel)
                            scope.qmModel = !scope.qmModel;
                        lastState = scope.qmModel;
                    };
                    scope.toggle = function () {
                        if (scope.qmDisabled)
                            return;
                        scope.qmModel = !scope.qmModel;
                    };
                    if (scope.qmColor != (null || undefined)) {
                        $(element).find('.squaredThree').children("label").css("border", "1px solid " + scope.qmColor);
                        if (scope.qmColor.toLowerCase() == '#ffffff')
                            $(element).find('.squaredThree').children("label").css("border", "1px solid lightgrey");
                        scope.$watch('qmModel', function (oldVal, newVal) {
                            if (scope.qmModel)
                                $(element).find('.squaredThree').children("label").css("background", scope.qmColor);
                            else {
                                if (scope.qmColor.toLowerCase() != '#ffffff') {
                                    $(element).find('.squaredThree').children("label").css("background", "white");
                                    $(element).find('.squaredThree').children("label").css("background-image", "unset");
                                }
                                else {
                                    $(element).find('.squaredThree').children("label").css("background", "lightgrey");
                                    $(element).find('.squaredThree').children("label").css("background-image", "repeating-linear-gradient(135deg, transparent, transparent 5px, rgba(255,255,255,.5)5px, rgba(255,255,255,.5) 10px");
                                }
                            }
                        });
                    }
                };
            }
            qmInputCheckbox = __decorate([
                QMC.Directive('QMC.Input', 'qmInputCheckbox', [])
            ], qmInputCheckbox);
            return qmInputCheckbox;
        }());
        Input.qmInputCheckbox = qmInputCheckbox;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var dateFormat = 'DD.MM.YYYY';
        var qmInputDate = /** @class */ (function () {
            function qmInputDate($qui) {
                var _this = this;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.dateIsDeleted = false;
                this.clearDate = true;
                this.scope = {
                    qmInit: '=',
                    qmModel: '=',
                    qmDisplayModel: '@',
                    qmStartDate: '=',
                    qmEndDate: '=',
                    qmPlaceholder: '@',
                    qmInvalidDate: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmRequired: '=',
                    qmDisabled: '=',
                    qmId: '=?',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmDisableDropDown: '@'
                };
                this.templateUrl = function () {
                    return (new qmDeviceSet()).isMobile() ? 'Input/Mobile/Date' : 'Input/Date';
                };
                this.link = function (scope, element, attrs) {
                    if (!scope.qmId || scope.qmId === 'd.id') {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    var mobile = (new qmDeviceSet()).isMobile();
                    function getRandomInt(min, max) {
                        return Math.floor(Math.random() * (max - min + 1)) + min;
                    }
                    scope.deleteDate = function () {
                        scope.qmModel = null;
                        scope.qmDisplayModel = null;
                        if (scope.qmRequired) {
                            _this.dateIsDeleted = true;
                            scope.qmInvalidDate = true;
                        }
                    };
                    _this.dateIsDeleted = false;
                    scope.qmInvalidDate = false;
                    element.attr("id", "date-" + getRandomInt(1, 999));
                    element.id = "date-" + getRandomInt(1, 999);
                    if (mobile.length === 0) {
                        scope.$watch('qmStartDate', function () {
                            if (scope.qmStartDate) {
                                element.find('.input-group.date').datepicker('setStartDate', scope.qmStartDate);
                                scope.clearDate = false;
                            }
                        });
                        scope.$watch('qmEndDate', function () {
                            if (scope.qmEndDate)
                                element.find('.input-group.date').datepicker('setEndDate', scope.qmEndDate);
                        });
                        scope.$watch('qmModel', function () {
                            if (scope.qmModel) {
                                scope.qmDisplayModel = moment(scope.qmModel).format(dateFormat);
                                _this.$qui.scopeApply(scope);
                                _this.dateIsDeleted = false;
                                scope.qmInvalidDate = false;
                            }
                            else {
                                scope.qmDisplayModel = null;
                            }
                        });
                        scope.$watch('qmDisplayModel', function (newVal, oldVal) {
                            if (newVal === oldVal || (!newVal && !oldVal))
                                return;
                            if (newVal && newVal.length) {
                                var input = moment(scope.qmDisplayModel, dateFormat);
                                if (input.isValid() && moment(scope.qmModel) !== input) {
                                    scope.qmModel = input.toDate();
                                    _this.dateIsDeleted = false;
                                    scope.qmInvalidDate = false;
                                }
                                else {
                                    scope.deleteDate();
                                }
                            }
                        });
                        /* Ahrrr! Datepicker ahoi */
                        element.find(".input-group.date").datepicker({
                            todayBtn: "linked",
                            todayHighlight: true,
                            format: {
                                toDisplay: function (date, format, language) {
                                    // DAA-3775 what is this, why was it here?
                                    //scope.qmModel = moment(date).hours(2).toDate();
                                    return moment(date).format(dateFormat);
                                },
                                toValue: function (date, format, language) {
                                    return date;
                                }
                            },
                            keyboardNavigation: false,
                            forceParse: false,
                            calendarWeeks: true,
                            language: 'de',
                            autoclose: true,
                            orientation: "bottom auto"
                        }).on('changeDate', function (data) {
                            scope.qmInvalidDate = false;
                            this.dateIsDeleted = false;
                            if (moment(data.date, dateFormat).isValid()) {
                                scope.qmDisplayModel = moment(data.date).format(dateFormat);
                                if (scope.qmStartDate && moment(data.date, dateFormat).isBefore(scope.qmStartDate))
                                    scope.qmDisplayModel = moment(scope.qmStartDate).format(dateFormat);
                                if (scope.qmEndDate && moment(data.date, dateFormat).isAfter(moment(scope.qmEndDate).endOf('day')))
                                    scope.qmDisplayModel = moment(scope.qmEndDate).format(dateFormat);
                                scope.qmModel = moment(data.date, dateFormat).toDate();
                            }
                            else if (scope.qmDisplayModel && scope.qmDisplayModel.length === 0) {
                                scope.deleteDate();
                            }
                            else {
                                scope.qmInvalidDate = true;
                                scope.qmModel = null;
                            }
                            element.find(".input-group.date").datepicker('hide');
                        }).on('clearDate', function (data) {
                            //somehow the clearDate event is triggered when the qmStartDate is changed, better handling the clearDate event using a variable that tells the event if the user really wants to clear the date
                            if (scope.clearDate) {
                                this.dateIsDeleted = true;
                                if (scope.qmRequired === true) {
                                    scope.qmInvalidDate = true;
                                    //keep the datePicker Calender opened so the user can still choose a date, in case they accidentaly pressed delete, the date is required, the user must select a date
                                }
                                else {
                                    element.find(".input-group.date").datepicker('hide');
                                }
                            }
                            scope.clearDate = true;
                        });
                        if (!scope.qmStartDate)
                            element.find('.input-group.date').datepicker('setStartDate', new Date(1753, 1, 1));
                        if (!scope.qmEndDate)
                            element.find('.input-group.date').datepicker('setEndDate', new Date(9999, 12, 31));
                    }
                    else {
                        scope.$watch('qmModel', function () {
                            if (scope.qmModel) {
                                scope.qmModel.setSeconds(0);
                                scope.qmModel.setMilliseconds(0);
                            }
                            _this.$qui.scopeApply(scope);
                        });
                    }
                    // HOTKEY HANDLING FROM HERE DOWN
                    scope.waitCounter = 0;
                    scope.waitForInit = function () {
                        var ele = document.getElementById(scope.qmId);
                        if (ele) {
                            document.getElementById(scope.qmId).onkeydown = function (event) {
                                var date = scope.qmModel;
                                if (!date)
                                    date = new Date();
                                switch (event.keyCode) {
                                    case 33: //pageUp, set start of Month
                                        if (event.shiftKey) { //year insted of month
                                            scope.qmModel = getStartEndDate(date, 'year', false);
                                        }
                                        else {
                                            scope.qmModel = getStartEndDate(date, 'month', false);
                                        }
                                        event.preventDefault();
                                        break;
                                    case 34: //pageDown, set end of Month
                                        if (event.shiftKey) { //year insted of month
                                            scope.qmModel = getStartEndDate(date, 'year', true);
                                        }
                                        else {
                                            scope.qmModel = getStartEndDate(date, 'month', true);
                                        }
                                        event.preventDefault();
                                        break;
                                    case 8: //delete button
                                        element.find(".input-group.date").datepicker('update', '');
                                        _this.dateIsDeleted = true;
                                        if (scope.qmRequired === true) {
                                            scope.qmInvalidDate = true;
                                            scope.qmModel = null;
                                            //keep the datePicker Calender opened so the user can still choose a date, in case they accidentaly pressed delete, the date is required, the user must select a date
                                        }
                                        else {
                                            element.find(".input-group.date").datepicker('hide');
                                        }
                                        break;
                                    default:
                                        break;
                                }
                                _this.$qui.scopeApply(scope);
                            };
                        }
                        else if (scope.waitCounter < 25) {
                            setTimeout(function () {
                                scope.waitForInit();
                                scope.waitCounter++;
                            }, 250);
                        }
                    };
                    scope.waitForInit();
                    var getStartEndDate = function (date, periodType, toEnd) {
                        var next;
                        if (toEnd)
                            next = moment(date).endOf(periodType).toDate();
                        else
                            next = moment(date).startOf(periodType).toDate();
                        if (next.toString() === date.toString()) {
                            if (toEnd)
                                next = moment(date).add(1, periodType + 's').toDate();
                            else
                                next = moment(date).add(-1, periodType + 's').toDate();
                        }
                        // make sure to really be at the end of period after adding
                        if (toEnd)
                            next = moment(next).endOf(periodType).toDate();
                        return next;
                    };
                    // CONTEXT HANDLING FROM HERE DOWN
                    scope.openSubMenu = function () {
                        var menu = document.getElementById('dd' + scope.qmId);
                        var dp = element.find('.input-group.date');
                        var input = document.getElementById(scope.qmId);
                        if (scope.qmDisableDropDown || !menu || !dp || scope.qmDisabled || input.hasAttribute('disabled'))
                            return;
                        if (!mobile || mobile.length === 0) {
                            setTimeout(function () {
                                dp.datepicker('hide');
                            });
                        }
                        scope.openDD('dd');
                    };
                    scope.setDate = function (target, period, num) {
                        if (target === '?')
                            target = scope.startOrEndOf;
                        if (period === 'quarter') {
                            switch (num) {
                                case 1:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('01/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('03/31/' + moment().get('year'));
                                    break;
                                case 2:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('04/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('06/30/' + moment().get('year'));
                                    break;
                                case 3:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('07/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('09/30/' + moment().get('year'));
                                    break;
                                case 4:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('10/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('12/31/' + moment().get('year'));
                                    break;
                            }
                            // if new date exceeds min/max bounds cap it there
                            if (scope.qmStartDate && moment(scope.qmStartDate).isAfter(scope.qmModel))
                                scope.qmModel = scope.qmStartDate;
                            if (scope.qmEndDate && moment(scope.qmEndDate).isBefore(scope.qmModel))
                                scope.qmModel = scope.qmEndDate;
                            return;
                        }
                        var result;
                        switch (target) {
                            case 'today':
                                result = new Date();
                                break;
                            case 'start':
                                result = getStartEndDate(new Date(), period, false);
                                break;
                            case 'end':
                                result = getStartEndDate(new Date(), period, true);
                                break;
                            case 'prev':
                                result = getStartEndDate(moment().set(period, moment().get(period) - 1), period, scope.startOrEndOf === 'end');
                                break;
                            case 'next':
                                result = getStartEndDate(moment().set(period, moment().get(period) + 1), period, scope.startOrEndOf === 'end');
                                break;
                            case 'targetMonth':
                                var temp = moment(scope.qmModel ? scope.qmModel : new Date());
                                temp = temp.set('year', scope.shortcutYear);
                                temp = temp.set('month', num);
                                // scope.qmModel = getStartEndDate(temp.toDate(), 'month', scope.startOrEndOf === 'end');
                                if (scope.startOrEndOf === 'end')
                                    temp = moment(temp).endOf('month');
                                else
                                    temp = moment(temp).startOf('month');
                                result = temp.toDate();
                                break;
                        }
                        // if new date exceeds min/max bounds cap it there
                        if (scope.qmStartDate && moment(scope.qmStartDate).isAfter(result))
                            result = scope.qmStartDate;
                        if (scope.qmEndDate && moment(scope.qmEndDate).isBefore(result))
                            result = scope.qmEndDate;
                        // Only trigger change when date has actually changed
                        if (!scope.qmModel || (moment(scope.qmModel).toDate().toDateString() !== moment(result).toDate().toDateString()) || _this.dateIsDeleted === true) {
                            scope.qmInvalidDate = false;
                            scope.qmModel = result;
                            if (!mobile && mobile.length === 0) {
                                element.find(".input-group.date").datepicker('update', scope.qmModel.toDateString());
                            }
                        }
                    };
                    scope.startOrEndOf = 'start';
                    scope.openStartEndOfDdn = function (mode) {
                        scope.openDD('dds');
                        scope.startOrEndOf = mode;
                    };
                    window.onclick = function (event) {
                        closeAllDropDown(false, event);
                    };
                    var closeAllDropDown = function (force, event) {
                        if (force || (event && event.target && !event.target.matches('.dropbtn') && !event.target.matches('.dontClose'))) {
                            var dropdowns = document.getElementsByClassName("date-dropdown");
                            for (var i = 0; i < dropdowns.length; i++) {
                                if (dropdowns[i].classList.contains('date-show')) {
                                    dropdowns[i].classList.remove('date-show');
                                }
                            }
                        }
                    };
                    scope.dateDropDownShurtcutYears = [];
                    scope.dateDropDownShurtcutYears.push(moment().get('year') - 1);
                    scope.dateDropDownShurtcutYears.push(moment().get('year'));
                    scope.dateDropDownShurtcutYears.push(moment().get('year') + 1);
                    scope.shortcutYear = moment().get('year');
                    scope.openShortcutYear = function (year) {
                        scope.openDD('ddy');
                        scope.shortcutYear = year;
                    };
                    scope.openDD = function (ddName) {
                        closeAllDropDown(true, null);
                        var menu = document.getElementById(ddName + scope.qmId);
                        setTimeout(function () {
                            if (menu)
                                menu.classList.toggle('date-show');
                            //try to place dropdown in visible area
                            var ancestor = element[0].parentNode.parentNode.parentNode;
                            if (scope.$parent === 'dateRange')
                                ancestor = ancestor.parentNode;
                            console.log(ancestor, ancestor.tagName, scope.$parent);
                            var containerRect = ancestor.getBoundingClientRect();
                            var lowerBound = containerRect.top + containerRect.height;
                            var menuRect = menu.firstElementChild.getBoundingClientRect();
                            var ddLowerEnd = menuRect.top + menuRect.height;
                            if (ddLowerEnd > lowerBound) {
                                menu.style.top = '-' + Math.min(ddLowerEnd - lowerBound + 15, containerRect.height) + 'px';
                            }
                            else {
                                menu.style = 'unset';
                            }
                        }, 1);
                    };
                };
            }
            qmInputDate = __decorate([
                QMC.Directive('QMC.Input', 'qmInputDate', ['$qui'])
            ], qmInputDate);
            return qmInputDate;
        }());
        Input.qmInputDate = qmInputDate;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputDateMonths = /** @class */ (function () {
            function qmInputDateMonths($qui, lngService) {
                var _this = this;
                this.$qui = $qui;
                this.lngService = lngService;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmDateFrom: '=',
                    qmDateTo: '=',
                    qmMonths: '=',
                    qmDisabled: '@'
                };
                this.templateUrl = 'Input/DateMonths';
                this.controller = ['$scope', function ($scope) {
                        $scope.createMonthList = function () {
                            var _a;
                            if ($scope.qmDateFrom == (null && undefined))
                                $scope.qmDateFrom = moment().startOf('month').toDate();
                            if ($scope.qmDateTo == (null && undefined))
                                $scope.qmDateTo = moment($scope.qmDateFrom).endOf('month').toDate();
                            var today = new Date();
                            $scope.monthsList = [];
                            $scope.yearList = [];
                            var monthNames = _this.lngService.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(',');
                            for (var i = 0; i < 12; i++) {
                                $scope.monthsList.push({
                                    value: moment(today).month(i).toISOString(),
                                    text: (_a = monthNames[i]) !== null && _a !== void 0 ? _a : moment.months()[i]
                                });
                            }
                            for (var i = ($scope.qmDateFrom.getFullYear() - 5); i < $scope.qmDateFrom.getFullYear() + 2; i++) {
                                $scope.yearList.push({
                                    value: i,
                                    text: i,
                                });
                            }
                            $scope.date = $scope.monthsList[$scope.qmDateFrom.getMonth()].value;
                            $scope.year = $scope.qmDateFrom.getFullYear();
                        };
                    }];
                this.link = function (scope, element, attrs) {
                    scope.createMonthList();
                    scope.changeDate = function () {
                        scope.qmDateFrom = moment(scope.date).startOf('month').year(scope.year).toDate();
                        scope.qmDateTo = moment(scope.date).endOf('month').year(scope.year).toDate();
                        if (scope.qmMonths === "year") {
                            scope.qmDateFrom = moment(scope.date).startOf('year').year(scope.year).toDate();
                            scope.qmDateTo = moment(scope.date).endOf('year').year(scope.year).toDate();
                        }
                    };
                };
            }
            qmInputDateMonths = __decorate([
                QMC.Directive('QMC.Input', 'qmInputDateMonths', ['$qui', 'QmcLanguageService'])
            ], qmInputDateMonths);
            return qmInputDateMonths;
        }());
        Input.qmInputDateMonths = qmInputDateMonths;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputDateRange = /** @class */ (function () {
            function qmInputDateRange($qui) {
                var _this = this;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmDateFrom: '=',
                    qmDateTo: '=',
                    qmOriginalTimeFrom: '=',
                    qmOriginalTimeTo: '=',
                    qmPlaceholderDateFrom: '@',
                    qmPlaceholderDateTo: '@',
                    qmDisableTime: "=",
                    qmDisableDate: "=",
                    qmDurationInHours: '=?',
                    qmDurationInDays: '@',
                    qmLabelDateFrom: '@',
                    qmLabelDateTo: '@',
                    qmValidTime: '=?',
                    qmValidDate: '=?',
                    qmRequired: '=',
                    qmEnableTime: '=',
                    qmEnableDateTo: '=',
                    qmRoundInterval: '=',
                    qmDisplayDuration: '=',
                    qmStartDate: '=',
                    qmEndDate: '=',
                    qmDisabled: '=',
                    qmDateFromNotRequired: '=?',
                    qmStartRoundType: '=',
                    qmEndRoundType: '='
                };
                this.templateUrl = 'Input/DateRange';
                this.link = function (scope, element, attrs) {
                    scope.type = 'dateRange';
                    scope.qmValidDate = true;
                    scope.qmValidTime = true;
                    scope.qmDurationInDays = 0;
                    scope.dateFromId = '_' + Math.random().toString(36).substr(2, 9);
                    scope.dateToId = '_' + Math.random().toString(36).substr(2, 9);
                    // Loading initial values
                    if (scope.qmDateFrom) {
                        scope.dateFrom = scope.qmDateFrom;
                        scope.timeFrom = scope.qmDateFrom;
                        scope.originalTimeFrom = scope.qmOriginalTimeFrom ? scope.qmOriginalTimeFrom : scope.qmDateFrom;
                    }
                    if (scope.qmDateTo) {
                        scope.dateTo = scope.qmDateTo;
                        scope.timeTo = scope.qmDateTo;
                        scope.originalTimeTo = scope.qmOriginalTimeTo ? scope.qmOriginalTimeTo : scope.qmDateTo;
                    }
                    if (scope.qmEnableTime) {
                        scope.qmDurationInHours = 0;
                        scope.qmValidTime = true;
                    }
                    scope.createListener = function () {
                        scope.qmDateFromWatcher = scope.$watch('qmDateFrom', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            scope.removeListener();
                            scope.dateFrom = scope.qmDateFrom ? _this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.timeFrom = scope.qmDateFrom ? _this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.dateTo = scope.qmDateTo ? _this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.timeTo = scope.qmDateTo ? _this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.validate();
                        }, true);
                        scope.qmDateToWatcher = scope.$watch('qmDateTo', function (newValue, oldValue) {
                            if (newValue === oldValue)
                                return;
                            scope.removeListener();
                            scope.dateTo = scope.qmDateTo ? _this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.timeTo = scope.qmDateTo ? _this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.dateFrom = scope.qmDateFrom ? _this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.timeFrom = scope.qmDateFrom ? _this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.validate();
                        }, true);
                        scope.dateFromListener = scope.$watch('dateFrom', function (newValue, oldValue) {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === (null || undefined))
                                scope.dateFrom = scope.qmStartDate ? scope.qmStartDate : getCurrentDate();
                            scope.removeListener();
                            if (scope.dateTo && scope.dateFrom > scope.dateTo) {
                                scope.dateTo = scope.dateFrom;
                            }
                            if (scope.qmRequired && !scope.dateTo)
                                scope.dateTo = scope.dateFrom;
                            scope.validate();
                        });
                        scope.dateToListener = scope.$watch('dateTo', function (newValue, oldValue) {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === (null || undefined))
                                scope.dateTo = scope.qmEndDate ? scope.qmEndDate : scope.qmRequired ? getCurrentDate() : null;
                            scope.removeListener();
                            if (scope.dateTo && scope.dateTo < scope.dateFrom) {
                                scope.dateFrom = scope.dateTo;
                            }
                            if (!scope.dateTo) {
                                scope.timeTo = null;
                            }
                            if (!scope.timeTo)
                                scope.timeTo = scope.dateTo;
                            scope.validate();
                        });
                        scope.timeFromListener = scope.$watch('timeFrom', function (newValue, oldValue) {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === (null || undefined))
                                scope.timeFrom = scope.qmStartDate ? scope.qmStartDate : getCurrentDate();
                            scope.removeListener();
                            scope.validate();
                        });
                        scope.timeToListener = scope.$watch('timeTo', function (newValue, oldValue) {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === (null || undefined))
                                scope.timeTo = scope.qmEndDate ? scope.qmEndDate : getCurrentDate();
                            scope.removeListener();
                            scope.validate();
                        });
                    };
                    scope.createListener();
                    var getCurrentDate = function () {
                        var date = new Date();
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        return date;
                    };
                    scope.removeListener = function () {
                        scope.qmDateToWatcher();
                        scope.qmDateFromWatcher();
                        scope.dateFromListener();
                        scope.dateToListener();
                        scope.timeFromListener();
                        scope.timeToListener();
                    };
                    scope.validate = function () {
                        scope.removeListener();
                        //if any value is null set its model null
                        try {
                            /**
                             * RoundTime
                             */
                            var setTimeFrom = scope.timeFrom ? _this.$qui.createDateFromString(scope.timeFrom).getHours() + ":" + _this.$qui.createDateFromString(scope.timeFrom).getMinutes() : '0:0';
                            var orgTimeFrom = scope.originalTimeFrom ? _this.$qui.createDateFromString(scope.originalTimeFrom).getHours() + ":" + _this.$qui.createDateFromString(scope.originalTimeFrom).getMinutes() : '0:0';
                            var setTimeTo = scope.timeTo ? _this.$qui.createDateFromString(scope.timeTo).getHours() + ":" + _this.$qui.createDateFromString(scope.timeTo).getMinutes() : '0:0';
                            var orgTimeTo = scope.originalTimeTo ? _this.$qui.createDateFromString(scope.originalTimeTo).getHours() + ":" + _this.$qui.createDateFromString(scope.originalTimeTo).getMinutes() : '0:0';
                            if (scope.qmRoundInterval && setTimeFrom != orgTimeFrom) {
                                scope.timeFrom = _this.$qui.roundTime(scope.timeFrom, scope.qmRoundInterval, true, scope.qmStartRoundType);
                            }
                            if (!scope.timeTo)
                                scope.timeTo = scope.dateTo;
                            if (scope.qmRoundInterval && setTimeTo != orgTimeTo) {
                                scope.timeTo = _this.$qui.roundTime(scope.timeTo, scope.qmRoundInterval, true, scope.qmEndRoundType);
                            }
                            scope.dateFrom = _this.$qui.addTimeToDate(scope.dateFrom, scope.timeFrom);
                            if (scope.dateTo) {
                                scope.dateTo = _this.$qui.addTimeToDate(scope.qmEnableDateTo ? scope.dateTo : scope.dateFrom, scope.timeTo);
                            }
                            scope.qmDurationInDays = 0;
                            scope.qmDurationInHours = 0;
                            scope.qmValidDate = true;
                            scope.qmValidTime = true;
                            scope.qmDurationInDays = _this.$qui.getDurationInDays(scope.dateFrom, scope.dateTo);
                            if (scope.qmDurationInDays < 0 && scope.qmRequired) {
                                scope.qmValidDate = false;
                            }
                            if (scope.qmDurationInDays >= 1)
                                scope.qmValidTime = true;
                            scope.qmDateFrom = _this.$qui.addTimeToDate(scope.dateFrom, scope.timeFrom);
                            scope.qmDateTo = _this.$qui.addTimeToDate(scope.dateTo, scope.timeTo);
                            if (!scope.qmRequired && !moment(scope.qmDateTo).isValid()) {
                                scope.qmDateTo = null;
                            }
                            setTimeout(function () {
                                if (scope.dateFrom && scope.timeFrom)
                                    scope.qmDateFrom = _this.$qui.addTimeToDate(scope.dateFrom, scope.timeFrom);
                                if (scope.dateTo && scope.timeTo)
                                    scope.qmDateTo = _this.$qui.addTimeToDate(scope.dateTo, scope.timeTo);
                                if (scope.qmEnableTime && (scope.qmRequiered || (scope.timeFrom && scope.timeTo))) {
                                    var duration = moment.duration(moment(scope.qmDateTo).diff(moment(scope.qmDateFrom)));
                                    scope.qmDurationInHours = isNaN(Number(duration.asHours())) ? 0 : Number(duration.asHours());
                                    scope.qmValidTime = scope.qmDurationInHours >= 0 && !isNaN(Number(duration.asHours()));
                                }
                                _this.$qui.scopeApply(scope);
                                scope.createListener();
                            }, 50);
                        }
                        catch (e) {
                            console.warn('validation failed', e);
                            scope.createListener();
                        }
                    };
                    scope.removeListener();
                    scope.validate();
                    // HOTKEY HANDLING FROM HERE DOWN
                    setTimeout(function () {
                        if (scope.qmEnableDateTo && document.getElementById(scope.dateFromId) && document.getElementById(scope.dateToId)) {
                            document.getElementById(scope.dateFromId).onkeydown = function (event) {
                                setTimeout(function () {
                                    handleDateKeyEvent(event, 'from');
                                    _this.$qui.scopeApply(scope);
                                }, 50);
                            };
                            document.getElementById(scope.dateToId).onkeydown = function (event) {
                                setTimeout(function () {
                                    handleDateKeyEvent(event, 'to');
                                    _this.$qui.scopeApply(scope);
                                }, 50);
                            };
                        }
                    }, 500);
                    var handleDateKeyEvent = function (event, source) {
                        if (!(event.keyCode === 35 || event.keyCode === 36))
                            return;
                        event.preventDefault();
                        if (!scope.dateTo)
                            scope.dateTo = new Date();
                        var prevDate = {
                            from: scope.dateFrom,
                            to: scope.dateTo
                        };
                        var periodType = 'month';
                        if (event.shiftKey) {
                            periodType = 'year';
                        }
                        if (!event.altKey) {
                            if (event.shiftKey) {
                                scope.dateFrom = moment(scope.dateFrom).startOf('year').toDate();
                                scope.dateTo = moment(scope.dateTo).endOf('year').toDate();
                            }
                            scope.dateFrom = moment(scope.dateFrom).startOf('month').toDate();
                            scope.dateTo = moment(scope.dateTo).endOf('month').toDate();
                            if (prevDate.from.setHours(0, 0, 0, 0) === scope.dateFrom.setHours(0, 0, 0, 0) && prevDate.to.setHours(0, 0, 0, 0) === scope.dateTo.setHours(0, 0, 0, 0)) {
                                if (event.keyCode === 35) {
                                    scope.dateFrom = moment(scope.dateFrom).add(1, periodType).toDate();
                                    scope.dateTo = moment(scope.dateTo).add(1, periodType).toDate();
                                }
                                else {
                                    scope.dateFrom = moment(scope.dateFrom).add(-1, periodType).toDate();
                                    scope.dateTo = moment(scope.dateTo).add(-1, periodType).toDate();
                                }
                            }
                            // make finally sure to be at start/end of month
                            scope.dateFrom = moment(scope.dateFrom).startOf('month').toDate();
                            scope.dateTo = moment(scope.dateTo).endOf('month').toDate();
                        }
                        else {
                            // alt key pressed on  home count from one period down, on end count to up
                            if (event.keyCode === 36) {
                                scope.dateFrom = moment(scope.dateFrom).add(-1, periodType).toDate();
                            }
                            else {
                                scope.dateTo = moment(scope.dateTo).add(1, periodType).toDate();
                            }
                        }
                        _this.$qui.scopeApply(scope);
                    };
                };
            }
            qmInputDateRange = __decorate([
                QMC.Directive('QMC.Input', 'qmInputDateRange', ['$qui'])
            ], qmInputDateRange);
            return qmInputDateRange;
        }());
        Input.qmInputDateRange = qmInputDateRange;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputFile = /** @class */ (function () {
            function qmInputFile(lng) {
                var _this = this;
                this.lng = lng;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmId: '@',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmDisabled: '=',
                    qmModel: '=?',
                    qmAccept: '=?'
                };
                this.templateUrl = 'Input/File';
                this.link = function (scope, element, attrs) {
                    // set defaults
                    if (!scope.qmIcon)
                        scope.qmIcon = 'fa fa-paperclip';
                    if (!scope.qmId)
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    if (!scope.qmModel)
                        scope.qmModel = [];
                    scope.data = {
                        filenames: [],
                        uploads: []
                    };
                    scope.openFileSelector = function () {
                        document.getElementById(scope.qmId).click();
                    };
                    scope.$watch('data', function () {
                        scope.addFile();
                    }, true);
                    scope.addFile = function () {
                        if (scope.data.filenames.length > 0 && scope.data.uploads.length > 0) {
                            var file_1 = {
                                name: scope.data.filenames[0],
                                base64: scope.data.uploads[0].split(',')[1]
                            };
                            if (scope.allowedFileTypes && !scope.allowedFileTypes.split(',').some(function (x) { return x.includes(file_1.name.split('.').pop()); })) {
                                alert(_this.lng.translate(20000314, 'Der ausgewählte Dateityp wird nicht unterstützt') + " (" + file_1.name.split('.').pop() + ").");
                                return;
                            }
                            scope.qmModel.push(file_1);
                            scope.data.filenames = [];
                            scope.data.uploads = [];
                            scope.loading = false;
                            $('#' + scope.qmId).val('');
                        }
                    };
                };
            }
            qmInputFile = __decorate([
                QMC.Directive('QMC.Input', 'qmInputFile', ['QmcLanguageService'])
            ], qmInputFile);
            return qmInputFile;
        }());
        Input.qmInputFile = qmInputFile;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputNumber = /** @class */ (function () {
            function qmInputNumber($qui) {
                var _this = this;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmRequired: '=',
                    qmMaxLength: '@',
                    qmName: '@',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmId: '=?',
                    qmClass: '@',
                    qmDisabled: '=',
                    qmMinValue: '=?',
                    qmMaxValue: '=?',
                    qmDisableDecimal: '=?',
                    qmDisplayRound: '=?'
                };
                this.templateUrl = 'Input/Number';
                this.link = function (scope, element, attrs) {
                    if (!scope.qmId || scope.qmId === 'd.id') {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    var seperator = (1.1).toLocaleString().substring(1, 2);
                    // if a max length (count of digits) is set, adjust max/min value accordingly to let browser handle it
                    if (scope.qmMaxLength) {
                        var maxLength = parseInt(scope.qmMaxLength);
                        var lengthString = '';
                        for (var i = 0; i < maxLength; i++)
                            lengthString += '9';
                        scope.qmMaxValue = scope.qmMaxValue ? Math.min(Number(lengthString), Number(scope.qmMaxValue)) : lengthString;
                        scope.qmMinValue = scope.qmMinValue ? Math.max(Number('-' + lengthString), Number(scope.qmMinValue)) : '-' + lengthString;
                    }
                    //DA-2627 done right
                    element[0].addEventListener('mouseover', function () { scope.respectSpinner = true; });
                    element[0].addEventListener('mouseout', function () { scope.respectSpinner = false; });
                    if (!scope.qmDisableDecimal || scope.qmDisableDecimal === undefined)
                        scope.qmDisableDecimal = false;
                    if (!scope.qmMinValue || scope.qmMinValue === undefined)
                        scope.qmMinValue = 0;
                    if (!scope.qmMaxLength || scope.qmMaxLength > 12) {
                        scope.qmMaxLength = 12;
                    }
                    _this.$qui.waitForEl('#' + scope.qmId, function () {
                        // input validation
                        $('#' + scope.qmId).on('keydown', function (event) {
                            var _a;
                            var key = event.originalEvent.key;
                            var currentValue = ((_a = scope.displayModel) !== null && _a !== void 0 ? _a : '') + '';
                            //for non browsers (edge, ie): replace commas with dots in real-time (for en-US locals)
                            if ((window.navigator.userAgent.indexOf("Trident") > -1 || navigator.userAgent.indexOf("Edge") > -1) && (key === ',')) {
                                event.preventDefault();
                                seperator = '.';
                                $(_this).val($(_this).val() + ".");
                            }
                            switch (key) {
                                case '.':
                                case ',':
                                    if (scope.qmDisableDecimal || currentValue.indexOf('.') >= 0 || currentValue.indexOf(',') >= 0 || key !== seperator)
                                        event.preventDefault();
                                    break;
                                case '-':
                                    if (scope.qmMinValue > -1 || currentValue.indexOf('-') >= 0)
                                        event.preventDefault();
                                    break;
                                case 'ArrowUp':
                                case 'ArrowDown':
                                    event.preventDefault();
                                    break;
                            }
                        });
                    });
                    scope.$watch('qmModel', function (newVal, oldVal) {
                        if (newVal === oldVal)
                            return;
                        if (scope.qmModel === undefined || scope.qmModel === null) {
                            scope.displayModel = 0;
                            return;
                        }
                        if (typeof scope.qmModel !== 'number')
                            scope.qmModel = Number(scope.qmModel);
                        scope.blur();
                    });
                    scope.$watch('displayModel', function (newVal, oldVal) {
                        if (!newVal && scope.qmMinValue < 0) {
                            scope.qmModel = undefined;
                            return;
                        }
                        if (newVal === undefined || newVal === oldVal || (!element.find('input').is(":focus") && !scope.respectSpinner))
                            return;
                        scope.qmModel = scope.validateNumber(scope.displayModel);
                        scope.blur();
                    });
                    scope.focus = function () {
                        scope.displayModel = Number(scope.qmModel + '');
                        element.find('input').select();
                    };
                    scope.blur = function () {
                        if (isNaN(scope.qmModel) || (scope.qmModel + '').length === 0) {
                            scope.displayValue = undefined;
                            return;
                        }
                        scope.displayModel = Number(scope.qmModel);
                        if (scope.qmDisplayRound && !element.find('input').is(":focus")) {
                            scope.displayModel = Number(scope.qmModel.toFixed(scope.qmDisplayRound));
                        }
                        _this.$qui.scopeApply(scope);
                    };
                    scope.validateNumber = function (number) {
                        if (number === undefined || number === null || number === '')
                            return 0;
                        var result = Number(number + '');
                        // check minValue
                        if (result < Number(scope.qmMinValue + ''))
                            result = Number(scope.qmMinValue + '');
                        // check maxValue
                        if (result > Number(scope.qmMaxValue + ''))
                            result = Number(scope.qmMaxValue + '');
                        // get rid of unwanted decimals
                        if (scope.qmDisableDecimal) {
                            var inputString = result + '';
                            if (inputString.indexOf(',') > 0)
                                result = Number(inputString.substring(0, inputString.indexOf(',')));
                            if (inputString.indexOf('.') > 0)
                                result = Number(inputString.substring(0, inputString.indexOf('.')));
                        }
                        return result;
                    };
                    scope.blur();
                };
            }
            qmInputNumber = __decorate([
                QMC.Directive('QMC.Input', 'qmInputNumber', ['$qui'])
            ], qmInputNumber);
            return qmInputNumber;
        }());
        Input.qmInputNumber = qmInputNumber;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputPassword = /** @class */ (function () {
            function qmInputPassword() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmChange: '=',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmRequired: '@',
                    qmMinlength: '@',
                    qmMaxlength: '@',
                    qmDisabled: '@',
                    qmPattern: '@',
                    qmTrim: '@',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmId: '@'
                };
                this.templateUrl = 'Input/Password';
                this.link = function (scope, element, attrs) {
                    scope.isPW = true;
                    if (scope.qmId == (null || undefined)) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    if (attrs.hasOwnProperty("qmLongtext")) {
                        element.find("input").attr("maxlength", 255);
                    }
                };
            }
            qmInputPassword = __decorate([
                QMC.Directive('QMC.Input', 'qmInputPassword', [])
            ], qmInputPassword);
            return qmInputPassword;
        }());
        Input.qmInputPassword = qmInputPassword;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var InputSelect = /** @class */ (function () {
            function InputSelect(wvService, permissionService, lng, $qui, $timeout) {
                var _this = this;
                this.wvService = wvService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.$qui = $qui;
                this.$timeout = $timeout;
                this.restrict = 'E';
                //replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmData: '=',
                    qmId: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmClass: '@',
                    qmRequired: '=',
                    qmDisabled: '=',
                    qmPattern: '@',
                    qmTrim: '@',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmShowCheckbox: '@',
                    qmCheckboxModel: '=',
                    qmKeepEmptyGuidItems: '@',
                    qmIcon: '@',
                    qmWvId: '@',
                    qmSubWvId: '=?',
                    qmWvData: '=?',
                    qmWvValueType: '@?',
                    qmKeepOrder: '=?'
                };
                this.templateUrl = function (element, attrs) {
                    if (attrs.hasOwnProperty('multiple')) {
                        return 'Input/SelectMulti';
                    }
                    else {
                        return 'Input/Select';
                    }
                };
                this.link = function (scope, element, attrs) {
                    scope.vm = scope;
                    var originalPlaceholder = scope.qmPlaceholder;
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    setTimeout(function () {
                        element.find('.ui.select.container').attr('id', scope.qmId);
                        if (attrs.hasOwnProperty('multiple') && scope.qmPlaceholder != (null || undefined)) {
                            element.find('.ui-select-search').attr('placeholder', scope.qmPlaceholder);
                        }
                    }, 200);
                    scope.getDataWithoutEmpty = function (data, search) {
                        if (!data)
                            return [];
                        if (search !== null && search !== undefined && search.length > 0) {
                            return data.filter(function (x) {
                                var _a, _b;
                                return (x.value && (x.value !== '00000000-0000-0000-0000-000000000000' || scope.qmKeepEmptyGuidItems != null)) &&
                                    (x.text.toUpperCase().includes(search.toUpperCase()) || ((_a = x.group) === null || _a === void 0 ? void 0 : _a.toUpperCase().includes(search.toUpperCase())) || ((_b = x.subText) === null || _b === void 0 ? void 0 : _b.join(';').toUpperCase().includes(search.toUpperCase())));
                            });
                        }
                        else {
                            return data.filter(function (x) { return x.value && (x.value !== '00000000-0000-0000-0000-000000000000' || scope.qmKeepEmptyGuidItems != null); });
                        }
                    };
                    scope.$watch('qmCheckboxModel', function (oldVal, newVal) {
                        if (oldVal === newVal || scope.qmCheckboxModel === null)
                            return;
                        if (!scope.qmCheckboxModel) {
                            scope.qmModel = [];
                        }
                        else {
                            for (var i = 0; i < scope.qmData.length; i++) {
                                scope.qmModel.push(scope.qmData[i].value);
                            }
                        }
                    });
                    scope.$watch('qmData', function (oldVal, newVal) {
                        if (!scope.qmData || !Array.isArray(scope.qmData) || scope.qmKeepOrder)
                            return;
                        scope.qmData = scope.qmData.sort(function (a, b) { var _a, _b; return ((_a = a.text) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.text) !== null && _b !== void 0 ? _b : ''); }, undefined, { sensitivity: 'base' }).sort(function (a, b) { var _a, _b; return ((_a = a.group) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.group) !== null && _b !== void 0 ? _b : ''); }, undefined, { sensitivity: 'base' });
                        scope.qmData.forEach(function (data) {
                            if (!data.subText)
                                data.subText = [];
                            if (!Array.isArray(data.subText))
                                data.subText = [data.subText];
                        });
                    });
                    /********** WV handling from here ***********/
                    scope.promptId = "prompt-" + scope.qmId;
                    scope.promptOptions = {
                        title: _this.lng.translate(20000302, "Katalogeintrag"),
                        yesNo: true,
                        icon: "qm-icon-arrow_into",
                        text: _this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                    };
                    scope.formState = 'new';
                    var wvPermissionStorage = 'wvPermissionCache';
                    var lastValue;
                    if (scope.qmSubWvId) {
                        scope.$watch('qmSubWvId', function (newVal) {
                            if ((newVal === lastValue || !newVal) && scope.qmWvData)
                                return;
                            lastValue = newVal;
                            scope.qmData = [];
                            scope.qmWvData = undefined;
                            if (newVal !== QMC.Common.Constants.GUID_EMPTY)
                                scope.loadWv(scope.qmWvId);
                        });
                    }
                    var getPermissionType = function () {
                        var cache = window[wvPermissionStorage + "_" + scope.qmWvId];
                        if (!cache) {
                            window[wvPermissionStorage + "_" + scope.qmWvId] = 'loading';
                            _this.permissionService.getPermissionsForDataset(scope.qmWvId, null).then(function (data) {
                                window[wvPermissionStorage + "_" + scope.qmWvId] = data[0];
                            });
                        }
                    };
                    var getPermission = function () {
                        var cache = window[wvPermissionStorage];
                        var dsPerm = window[wvPermissionStorage + "_" + scope.qmWvId];
                        if (scope.loadWvPerm || cache === 'loading' || !dsPerm || dsPerm === 'loading') {
                            setTimeout(function () { getPermission(); }, 250);
                            return;
                        }
                        scope.loadWvPerm = true;
                        //seems like winclient dont care about catalogmanager permission at all when directly manipulating wvs so we just assume everything is true. i'll leave the old code here anyway
                        scope.newWv = dsPerm.new;
                        scope.modifyWv = dsPerm.modify;
                        scope.deleteWv = dsPerm.delete;
                        scope.viewWv = true;
                        scope.loadWvPerm = false;
                        //if (cache && cache !== 'loading') {
                        //    const parsedCache = window[wvPermissionStorage];
                        //    scope.newWv = parsedCache.new && dsPerm.new;
                        //    scope.modifyWv = parsedCache.modify && dsPerm.modify;
                        //    scope.deleteWv = parsedCache.delete && dsPerm.delete;
                        //    scope.viewWv = parsedCache.moduleAccess;
                        //    scope.loadWvPerm = false;
                        //}
                        //else {
                        //    window[wvPermissionStorage] = 'loading';
                        //    scope.loadWvPerm = true;
                        //    this.permissionService.getPermissionsByObjectType(870008).then((data) => {
                        //        window[wvPermissionStorage] = data[0];
                        //        scope.newWv = data[0].new && dsPerm.new;
                        //        scope.modifyWv = data[0].modify && dsPerm.modify;
                        //        scope.deleteWv = data[0].delete && dsPerm.delete;
                        //        scope.viewWv = data[0].moduleAccess;
                        //    }).finally(() => {
                        //        scope.loadWvPerm = false;
                        //    });
                        //}
                        _this.$qui.scopeApply(scope);
                    };
                    if (scope.qmWvId) {
                        getPermission();
                        getPermissionType();
                    }
                    scope.initForm = function () {
                        scope.formState = 'new';
                        scope.form = {
                            id: null,
                            objectId: null,
                            comment: '',
                            name: '',
                            shortName: '',
                            value: null,
                            idReferencedObject: null,
                            isFix: false,
                            idSubtype: scope.qmWvId,
                            parentWvId: null
                        };
                        addValueConfigToForm();
                    };
                    var lastParent = undefined;
                    scope.openWv = function () {
                        if (scope.qmSubWvId && scope.qmSubWvId === QMC.Common.Constants.GUID_EMPTY) {
                            console.warn('Got a parent id but its guidempty, so the dev prop. messed up. Im not opening!');
                            return;
                        }
                        if (lastParent && lastParent !== scope.qmSubWvId) {
                            scope.qmWvData = undefined;
                        }
                        lastParent = scope.qmSubWvId;
                        if (!scope.qmWvData) {
                            scope.loadWv(scope.qmWvId);
                        }
                        else {
                            prepareData();
                        }
                        scope.formModalTitle = (scope.qmLabel && scope.qmLabel.length > 0 ? scope.qmLabel + ' - ' : '') + _this.lng.translate(20000302, 'Katalogeintrag');
                        scope.tableScheme.table.Farbe.invisible = scope.qmWvValueType && scope.qmWvValueType === 'color' ? false : true;
                        $('#wvModal-' + scope.qmId).modal('show');
                    };
                    scope.loadWv = function (id) {
                        scope.wvLoad = true;
                        scope.tableScheme.data = [];
                        scope.qmPlaceholder = _this.lng.translate(20000303, 'laden');
                        if (scope.qmSubWvId) {
                            if (id === '3e0d8030-1421-41b1-aed9-053d2d01a344') { //special case if subwvid is this, than it actual needs to be GuidEmpty for getting the data
                                id = QMC.Common.Constants.GUID_EMPTY;
                            }
                            _this.wvService.getSubWvList(id, scope.qmSubWvId).then(function (data) {
                                scope.qmWvData = data;
                                prepareData();
                            }).finally(function () {
                                scope.wvLoad = false;
                            });
                        }
                        else {
                            _this.wvService.getWvList(id).then(function (data) {
                                scope.qmWvData = data;
                                prepareData();
                            }).finally(function () {
                                scope.wvLoad = false;
                            });
                        }
                    };
                    var prepareData = function () {
                        markSelectedItems(scope.qmWvData);
                        scope.tableScheme.data = scope.qmWvData.filter(function (x) { return x.objectId && x.objectId != QMC.Common.Constants.GUID_EMPTY; }); // Filter empty values
                        if (scope.qmWvValueType === 'color') { // format int value to hex for use with remaining components
                            for (var _i = 0, _a = scope.qmWvData; _i < _a.length; _i++) {
                                var item = _a[_i];
                                if (item.value && (item.value + '').charAt(0) !== '#') { // value exists and does not begin with a #, therefor its not a hexcolor
                                    item.value = _this.$qui.intToHex(item.value);
                                }
                            }
                        }
                        scope.qmData = scope.tableScheme.data.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                        if (!scope.qmRequired && !attrs.hasOwnProperty('multiple')) {
                            scope.qmData.unshift({ text: '', value: QMC.Common.Constants.GUID_EMPTY });
                        }
                        _this.$qui.functionWaiter("vm.createTable", scope);
                        if (scope.qmData.filter(function (x) { return x.value === scope.qmModel; }).length === 0)
                            scope.qmModel = null;
                        scope.qmPlaceholder = originalPlaceholder;
                    };
                    scope.setSelection = function (checked, item) {
                        var id = item.objectId ? item.objectId : item.id;
                        if (checked) {
                            if (attrs.hasOwnProperty('multiple')) {
                                scope.qmModel.push(id);
                            }
                            else {
                                scope.qmModel = id;
                                // deselect all other values
                                for (var _i = 0, _a = scope.tableScheme.data; _i < _a.length; _i++) {
                                    var element_1 = _a[_i];
                                    element_1.active = id === element_1.objectId;
                                }
                                for (var _b = 0, _c = scope.items; _b < _c.length; _b++) {
                                    var element_2 = _c[_b];
                                    // hacky way to actually manipulate the tables view data, replaces old way of recreating table
                                    element_2.undefined.selected = id === element_2.undefined.id;
                                }
                            }
                        }
                        else {
                            if (attrs.hasOwnProperty('multiple')) {
                                scope.qmModel = scope.qmModel.filter(function (x) { return x !== id; });
                            }
                            else if (scope.qmModel === id) {
                                scope.qmModel = QMC.Common.Constants.GUID_EMPTY;
                            }
                        }
                        // when a currently selected value is updated, select-ui would not update the displayed text. To force that, we reset the selection wait a little and than put it back in :/
                        var model = scope.qmModel;
                        scope.qmModel = undefined;
                        _this.$qui.scopeApply(scope);
                        _this.$timeout(function () { scope.qmModel = model; }, 50);
                    };
                    var markSelectedItems = function (list) {
                        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                            var item = list_1[_i];
                            if (attrs.hasOwnProperty('multiple')) {
                                item.active = scope.qmModel.some(function (x) { return x.objectId; });
                            }
                            else {
                                item.active = scope.qmModel === item.objectId;
                            }
                        }
                    };
                    var formatFormValueForRequest = function (form) {
                        if (form.isColor) {
                            form.value = _this.$qui.hexToInt(form.value);
                        }
                    };
                    scope.newWvEntry = function () {
                        scope.initForm();
                        $("#edit-form-" + scope.qmId).modal('show');
                        _this.$qui.scopeApply(scope);
                    };
                    scope.postWvEntry = function () {
                        scope.wvLoad = true;
                        var form = angular.copy(scope.form);
                        formatFormValueForRequest(form);
                        if (scope.qmSubWvId)
                            _this.wvService.postSubWv(form.idSubtype, scope.qmSubWvId, form).then(function (data) {
                                form.id = data.createdId;
                                form.objectId = data.createdObjectId;
                                scope.setSelection(true, form);
                            }).finally(function () {
                                scope.loadWv(form.idSubtype);
                                scope.formState = 'new';
                            });
                        else
                            _this.wvService.postWv(form.idSubtype, form).then(function (data) {
                                form.id = data.createdId;
                                form.objectId = data.createdObjectId;
                                scope.setSelection(true, form);
                            }).finally(function () {
                                scope.loadWv(form.idSubtype);
                                scope.formState = 'new';
                            });
                    };
                    scope.editWvEntry = function (data) {
                        scope.form = data;
                        addValueConfigToForm();
                        scope.formState = 'edit';
                        $("#edit-form-" + scope.qmId).modal('show');
                        _this.$qui.scopeApply(scope);
                    };
                    scope.putWvEntry = function () {
                        scope.wvLoad = true;
                        var form = angular.copy(scope.form);
                        formatFormValueForRequest(form);
                        if (scope.qmSubWvId)
                            _this.wvService.putSubWv(form.idSubtype, scope.qmSubWvId, form.objectId, form).finally(function () {
                                scope.loadWv(form.idSubtype);
                                scope.setSelection(true, form);
                                scope.formState = 'new';
                            });
                        else
                            _this.wvService.putWv(form.idSubtype, form.objectId, form).finally(function () {
                                scope.loadWv(form.idSubtype);
                                scope.setSelection(true, form);
                                scope.formState = 'new';
                            });
                    };
                    scope.deleteWvEntry = function (item) {
                        scope.promptOptions.itemText = item.name;
                        QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                            if (data) {
                                scope.wvLoad = true;
                                if (scope.qmSubWvId)
                                    _this.wvService.deleteSubWv(item.idSubtype, scope.qmSubWvId, item.objectId).finally(function () {
                                        scope.loadWv(item.idSubtype);
                                    });
                                else
                                    _this.wvService.deleteWv(item.idSubtype, item.objectId).finally(function () {
                                        scope.loadWv(item.idSubtype);
                                    });
                                if (attrs.hasOwnProperty('multiple')) {
                                    scope.qmModel = scope.qmModel.filter(function (x) { return x !== item.objectId; });
                                }
                                else if (scope.qmModel === item.objectId) {
                                    scope.qmModel = QMC.Common.Constants.GUID_EMPTY;
                                }
                            }
                        }, '#' + scope.promptId);
                    };
                    var addValueConfigToForm = function () {
                        // use an if to not create to many useless probs in form
                        if (scope.qmWvValueType === 'color')
                            scope.form.isColor = true;
                    };
                    scope.formInvalid = function () {
                        var _a;
                        // lets get hacky :/ since we use a readymade input for the name field and it its required, a potential surrounding form would fail to validate if we just set qm-required on it
                        // thats why we add the startisk to its label by code and manually validate the 'form' (#NotAForm). tahts also the reason why the edit modal is no longer a qm-form directive.
                        var textField = (_a = element.find("#wvName_" + scope.qmId)[0]) === null || _a === void 0 ? void 0 : _a.children[0];
                        if (textField)
                            textField.innerHTML = _this.lng.translate(20000053, 'Bezeichnung') + ' *';
                        return !scope.form || (!scope.form.name || scope.form.name.length === 0);
                    };
                    scope.tableScheme = {
                        "config": {
                            "defaultSort": "name",
                        },
                        "filter": {
                            model: null
                        },
                        "table": {
                            "Active": {
                                "id": "objectId",
                                "selected": "active",
                                "dType": "Checkbox",
                                "noHeader": true,
                                "events": {
                                    "onChange": "setSelection"
                                }
                            },
                            "Kürzel": {
                                "label": "shortName",
                                "dType": "string",
                                "lngTag": "20000221"
                            },
                            "Bezeichnung": {
                                "label": "name",
                                "dType": "string",
                                "lngTag": "20000053"
                            },
                            "Bemerkung": {
                                "label": "comment",
                                "dType": "string",
                                "lngTag": "20000049"
                            },
                            "Farbe": {
                                "label": "value",
                                "dType": "Color",
                                "lngTag": "20000300"
                            },
                            "Aktionen": [
                                {
                                    "icon": "qm-icon-pencil blue",
                                    "click": "editWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Bearbeiten",
                                    "lngTag": "20000044",
                                    "permission": "modifyWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }, {
                                    "icon": "qm-icon-garbage_can red",
                                    "click": "deleteWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Löschen",
                                    "lngTag": "20000002",
                                    "permission": "deleteWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }
                            ]
                        }, "card": {
                            "avatar": {
                                "icon": "qm-icon-arrow_into",
                            },
                            "checkbox": {
                                "selected": "active",
                                "events": {
                                    "onChange": "setSelection"
                                }
                            },
                            "text": {
                                "label": "name",
                                "dType": "string"
                            },
                            "subtext": [
                                {
                                    "label": "shortName",
                                    "dType": "string"
                                }
                            ],
                            "buttons": [
                                {
                                    "icon": "qm-icon-pencil blue",
                                    "click": "editWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Bearbeiten",
                                    "lngTag": "20000044",
                                    "permission": "modifyWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }, {
                                    "icon": "qm-icon-garbage_can red",
                                    "click": "deleteWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Löschen",
                                    "lngTag": "20000002",
                                    "permission": "deleteWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }
                            ]
                        },
                        "data": null,
                    };
                };
            }
            InputSelect = __decorate([
                QMC.Directive('QMC.Input', 'qmSelect', ['QmcWvService', 'QmcPermissionService', 'QmcLanguageService', '$qui', '$timeout'])
            ], InputSelect);
            return InputSelect;
        }());
        Input.InputSelect = InputSelect;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var SignaturePadComponent = /** @class */ (function () {
            function SignaturePadComponent($qui, $window, $timeout, $element, scope) {
                var _this = this;
                this.$qui = $qui;
                this.$window = $window;
                this.$timeout = $timeout;
                this.scope = scope;
                this.EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
                this.$postLink = function () {
                    _this.clear = function () {
                        _this.signaturePad.clear();
                        _this.dataurl = undefined;
                    };
                    _this.accept = function () {
                        var signature = { dataUrl: _this.EMPTY_IMAGE, isEmpty: true };
                        if (!_this.signaturePad.isEmpty()) {
                            signature.dataUrl = _this.signaturePad.toDataURL();
                            signature.isEmpty = false;
                        }
                        return signature;
                    };
                    angular.element(_this.$window).bind('resize', function () {
                        _this.onResize();
                    });
                    _this.scope.$watch("vm.height", function () {
                        _this.onResize();
                    });
                    _this.scope.$watch("vm.width", function () {
                        _this.onResize();
                    });
                    _this.scope.$watch("vm.dataurl", function (dataUrl) {
                        if (dataUrl) {
                            _this.signaturePad.fromDataURL(dataUrl);
                            _this.updateModel();
                        }
                    });
                    _this.signaturePad.addEventListener("endStroke", function () {
                        _this.updateModel();
                    });
                };
                this.canvas = $element.find('canvas')[0];
                this.signaturePad = new SignaturePad(this.canvas);
                $element.on('touchend', function () {
                    scope.$apply(function () {
                        // updateModel
                        _this.updateModel();
                    });
                });
                this.onResize();
            }
            SignaturePadComponent.prototype.updateModel = function () {
                var _this = this;
                // defer handling mouseup event until $scope.signaturePad handles first the same event
                this.$timeout()
                    .then(function () {
                    var result = _this.accept();
                    _this.dataurl = result.isEmpty ? undefined : result.dataUrl;
                });
            };
            ;
            SignaturePadComponent.prototype.onResize = function () {
                var prePic = this.signaturePad.toData();
                var canvasBoundingRect = this.canvas.getBoundingClientRect();
                var startWidth = this.canvas.width;
                var startHeight = this.canvas.height;
                var ratio = Math.max(this.$window.devicePixelRatio || 1, 1);
                this.canvas.width = this.canvas.offsetWidth * ratio;
                this.canvas.height = this.canvas.offsetHeight * ratio;
                this.canvas.getContext("2d").scale(ratio, ratio);
                this.signaturePad.minWidth = canvasBoundingRect.width / 300 / 1.5; //brush thickness
                this.signaturePad.maxWidth = canvasBoundingRect.width / 300 * 2; //brush thickness
                for (var _i = 0, prePic_1 = prePic; _i < prePic_1.length; _i++) {
                    var stroke = prePic_1[_i];
                    stroke.minWidth = canvasBoundingRect.width / 300 / 1.5; //brush thickness
                    stroke.maxWidth = canvasBoundingRect.width / 300 * 2; //brush thickness
                    for (var _a = 0, _b = stroke.points; _a < _b.length; _a++) {
                        var point = _b[_a];
                        point.x = point.x * (this.canvas.offsetWidth * ratio) / startWidth;
                        point.y = point.y * (this.canvas.offsetHeight * ratio) / startHeight;
                    }
                }
                this.signaturePad.fromData(prePic);
            };
            ;
            return SignaturePadComponent;
        }());
        //@Directive('QMC.Input', 'signaturePad', ['$qui', '$window', '$timeout'])
        angular.module('QMC.Input').component('signaturePad', {
            controller: ['$qui', '$window', '$timeout', '$element', '$scope', SignaturePadComponent],
            restrict: 'EA',
            replace: true,
            controllerAs: 'vm',
            bindings: {
                accept: '=?',
                clear: '=?',
                dataurl: '=?',
                height: '@?',
                width: '@?'
            },
            templateUrl: 'Input/SignaturePad'
        });
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputText = /** @class */ (function () {
            function qmInputText() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmChange: '=',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmClass: '@',
                    qmValue: '=',
                    qmRequired: '@',
                    qmMinLength: '@',
                    qmMaxLength: '@',
                    qmDisabled: '=',
                    qmPattern: '@',
                    qmTrim: '@',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmId: '@'
                };
                this.templateUrl = 'Input/Text';
                this.link = function (scope, element, attrs) {
                    if (scope.qmId == (null || undefined)) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                };
            }
            qmInputText = __decorate([
                QMC.Directive('QMC.Input', 'qmInputText', [])
            ], qmInputText);
            return qmInputText;
        }());
        Input.qmInputText = qmInputText;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var InputTextblock = /** @class */ (function () {
            function InputTextblock(mediaService, lng, $qui, filter, $sce) {
                var _this = this;
                this.mediaService = mediaService;
                this.lng = lng;
                this.$qui = $qui;
                this.filter = filter;
                this.$sce = $sce;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmId: '@',
                    qmOpen: '=',
                    qmInsert: '&'
                };
                this.templateUrl = 'Input/Textblock';
                this.link = function (scope) {
                    scope.formatted = false;
                    scope.inline = true;
                    var storageName = 'TextBlockCache';
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    if (localStorage.getItem(storageName + 'Format')) {
                        var cache = JSON.parse(localStorage.getItem(storageName + 'Format'));
                        scope.formatted = cache.formatted;
                        scope.inline = cache.inline;
                    }
                    scope.setFormatCache = function () {
                        localStorage.setItem(storageName + 'Format', JSON.stringify({
                            formatted: scope.formatted,
                            inline: scope.inline
                        }));
                    };
                    scope.laLabel = {
                        caption: _this.lng.translate(20000074, 'Lebensbereich'),
                        subCaption: _this.lng.translate(20016192, 'Unter-Lebensbereich')
                    };
                    scope.qmOpen = function () {
                        $('#textBlockModal_' + scope.qmId).modal('show');
                        initModal();
                        scope.initLASelect();
                    };
                    var initModal = function () {
                        var _a;
                        scope.loading = true;
                        scope.searchText = '';
                        ((_a = scope.textblocks) !== null && _a !== void 0 ? _a : []).forEach(function (item) { return item.isChecked = false; });
                        scope.setChecked();
                        var storage = sessionStorage.getItem(storageName);
                        // if cache is not set or older than five minutes, load data form server
                        if (!storage || (storage !== 'loading' && (new Date().getTime() - moment(JSON.parse(storage).timestamp).toDate().getTime() > 5 * 60 * 1000))) {
                            loadData();
                        }
                        else if (storage === 'loading') {
                            setTimeout(function () { initModal(); }, 500);
                        }
                        else {
                            scope.textblocks = JSON.parse(storage).data;
                            for (var _i = 0, _b = scope.textblocks; _i < _b.length; _i++) {
                                var block = _b[_i];
                                block.isChecked = false;
                            }
                            scope.loading = false;
                        }
                        _this.$qui.scopeApply(scope);
                    };
                    var loadData = function () {
                        sessionStorage.setItem(storageName, 'loading');
                        _this.mediaService.getTextBlocks().then(function (data) {
                            scope.textblocks = data;
                        }).catch(function () {
                            scope.textblocks = [];
                        }).finally(function () {
                            scope.loading = false;
                            sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), data: scope.textblocks }));
                        });
                    };
                    scope.getFilteredData = function () {
                        var blocks = _this.filter(scope.textblocks, scope.searchText);
                        if (scope.livingAreaId && scope.livingAreaId !== '00000000-0000-0000-0000-000000000000') {
                            blocks = blocks.filter(function (x) { return x.livingAreaId === scope.livingAreaId; });
                            if (scope.subLivingAreaId && scope.subLivingAreaId !== '00000000-0000-0000-0000-000000000000') {
                                blocks = blocks.filter(function (x) { return x.subLivingAreaId === scope.subLivingAreaId; });
                            }
                        }
                        return blocks;
                    };
                    scope.addCheckedTextBlocks = function () {
                        var result = [];
                        for (var _i = 0, _a = scope.textblocks; _i < _a.length; _i++) {
                            var block = _a[_i];
                            if (block.isChecked) {
                                if (scope.formatted) {
                                    result.push(scope.inline ? _this.stripParagraph(block.text) : block.text);
                                }
                                else {
                                    result.push(scope.inline ? block.previewText.replace(/(?:\r\n|\r|\n)/g, '<br>') : '<span><p>' + block.previewText.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</p></span>');
                                }
                            }
                        }
                        scope.qmInsert({ text: result.join(' ') });
                    };
                    scope.setChecked = function () {
                        var _a;
                        scope.selected = ((_a = scope.textblocks) !== null && _a !== void 0 ? _a : []).filter(function (x) { return x.isChecked; }).length;
                    };
                    scope.trustHtml = function (html) {
                        return _this.$sce.trustAsHtml(_this.stripParagraph(html));
                    };
                    scope.showPreview = function (textBlock) {
                        scope.textBlockPreview = textBlock;
                        $("#previewTextDialog_" + scope.qmId).modal('show');
                        scope.showPreviewFormatted = angular.copy(scope.formatted);
                    };
                };
            }
            InputTextblock.prototype.stripParagraph = function (input) {
                var _a;
                //only strip surrounding first paragraph, let others in place
                var div = document.createElement('div');
                div.innerHTML = input;
                var first = (_a = $(div).find('p:first')[0]) === null || _a === void 0 ? void 0 : _a.outerHTML;
                if (!first)
                    return input;
                first = first.replace(/(<p)/, '<span').replace(/<\/p([^<\/p]*)$/, '<\/span$1');
                $(div).find('p:first')[0].outerHTML = first;
                return div.innerHTML;
            };
            InputTextblock = __decorate([
                QMC.Directive('QMC.Input', 'qmInputTextblock', ['QmcMediaService', 'QmcLanguageService', '$qui', 'filterFilter', '$sce'])
            ], InputTextblock);
            return InputTextblock;
        }());
        Input.InputTextblock = InputTextblock;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var InputTexttemplate = /** @class */ (function () {
            function InputTexttemplate(mediaService, lng, $qui, filter) {
                var _this = this;
                this.mediaService = mediaService;
                this.lng = lng;
                this.$qui = $qui;
                this.filter = filter;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmId: '@',
                    qmOpen: '=',
                    qmInsert: '&'
                };
                this.templateUrl = 'Input/Texttemplate';
                this.link = function (scope) {
                    var storageName = 'TextTemplateCache';
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    scope.wvLabel = {
                        caption: _this.lng.translate(21006002, 'Hauptkategorie'),
                        subCaption: _this.lng.translate(21006003, 'Unterkategorie')
                    };
                    scope.qmOpen = function () {
                        $('#textTemplateModal_' + scope.qmId).modal('show');
                        initModal();
                        scope.initSelect();
                    };
                    var initModal = function () {
                        scope.loading = true;
                        var storage = sessionStorage.getItem(storageName);
                        // if cache is not set or older than five minutes, load data form server
                        if (!storage || (storage !== 'loading' && (new Date().getTime() - moment(JSON.parse(storage).timestamp).toDate().getTime() > 5 * 60 * 1000))) {
                            loadData();
                        }
                        else if (storage === 'loading') {
                            setTimeout(function () { initModal(); }, 500);
                        }
                        else {
                            scope.texttemplates = JSON.parse(storage).data;
                            scope.loading = false;
                        }
                        _this.$qui.scopeApply(scope);
                    };
                    var loadData = function () {
                        sessionStorage.setItem(storageName, 'loading');
                        _this.mediaService.getTextTemplates().then(function (data) {
                            scope.texttemplates = data;
                        }).catch(function () {
                            scope.texttemplates = [];
                        }).finally(function () {
                            scope.loading = false;
                            sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), data: scope.texttemplates }));
                        });
                    };
                    scope.getFilteredData = function () {
                        var blocks = _this.filter(scope.texttemplates, scope.searchText);
                        if (scope.categoryId && scope.categoryId !== '00000000-0000-0000-0000-000000000000') {
                            blocks = blocks.filter(function (x) { return x.categoryId === scope.categoryId; });
                            if (scope.subCategoryId && scope.subCategoryId !== '00000000-0000-0000-0000-000000000000') {
                                blocks = blocks.filter(function (x) { return x.subCategoryId === scope.subCategoryId; });
                            }
                        }
                        return blocks;
                    };
                    scope.add = function (item) {
                        scope.loading = true;
                        _this.mediaService.getTextTemplateContent(item.mediaId).then(function (content) {
                            scope.qmInsert({ text: content });
                        }).finally(function () {
                            scope.loading = false;
                            $('#textTemplateModal_' + scope.qmId).modal('hide');
                        });
                    };
                };
            }
            InputTexttemplate = __decorate([
                QMC.Directive('QMC.Input', 'qmInputTexttemplate', ['QmcMediaService', 'QmcLanguageService', '$qui', 'filterFilter'])
            ], InputTexttemplate);
            return InputTexttemplate;
        }());
        Input.InputTexttemplate = InputTexttemplate;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var qmInputTime = /** @class */ (function () {
            function qmInputTime($qui) {
                var _this = this;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmDisplayModel: '@',
                    qmPlaceholder: '=',
                    qmNoRow: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmRequired: '@',
                    qmInit: '@',
                    qmIcon: '@',
                    qmId: '@',
                    qmDisabled: '=',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@'
                };
                this.templateUrl = function () {
                    return (new qmDeviceSet()).isMobile() ? 'Input/Mobile/Time' : 'Input/Time';
                };
                this.link = function (scope, element, attrs) {
                    if (!scope.qmId || scope.qmId === 'd.id') {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    var mobile = (new qmDeviceSet()).isMobile();
                    scope.$watch('qmDisplayModel', function (newVal, oldVal) {
                        if (newVal === oldVal || (!newVal && !oldVal))
                            return;
                        if (newVal && newVal.length) {
                            // make sure to only allaw valid time inputs
                            if (scope.qmDisplayModel && scope.qmDisplayModel.length > 0) {
                                var splitted = scope.qmDisplayModel ? scope.qmDisplayModel.split(':') : [0, 0];
                                if (splitted.length === 2) {
                                    if (splitted[0] > 23) {
                                        splitted[0] = 23;
                                        splitted[1] = 59;
                                    }
                                    splitted[1] = parseInt(splitted[1]) > 59 ? 59 : splitted[1];
                                }
                                scope.qmDisplayModel = splitted[0] + ":" + splitted[1];
                            }
                        }
                        // if field is required but got deleted, restore previous state to ensure equirement status
                        else if (!newVal && scope.qmRequired) {
                            scope.qmDisplayModel = oldVal;
                        }
                    });
                    scope.$watch('qmModel', function (oldVal, newVal) {
                        if (oldVal === newVal || !scope.qmModel)
                            return;
                        if (!(scope.qmModel instanceof Date))
                            scope.qmModel = moment(newVal).toDate();
                        scope.qmModel.setSeconds(0);
                        scope.qmModel.setMilliseconds(0);
                    });
                    _this.$qui.timepicker();
                    if (scope.qmModel != (null || undefined)) {
                        if (!(scope.qmModel instanceof Date))
                            scope.qmModel = moment(scope.qmModel).toDate();
                        scope.qmModel.setSeconds(0);
                        scope.qmModel.setMilliseconds(0);
                    }
                    if (mobile.length == 0) {
                        scope.$watch('qmModel', function () {
                            scope.qmDisplayModel = null;
                            if (scope.qmModel != (null || undefined)) {
                                scope.qmDisplayModel = moment(scope.qmModel).format('HH:mm');
                            }
                        });
                        $('.clockpicker').clockpicker().find('input').change(function (event) {
                            event.stopPropagation();
                            scope.qmInit = scope.qmDisplayModel;
                            var time = scope.qmDisplayModel ? scope.qmDisplayModel.split(':') : [0, 0];
                            var model = new Date();
                            if (scope.qmModel == (null || undefined || 'Invalid Date'))
                                scope.qmModel = new Date();
                            if (moment(scope.qmDisplayModel, 'HH:mm').isValid()) {
                                if (time[0] >= 24)
                                    time[0] = 23;
                                if (time[1] >= 60)
                                    time[1] = 59;
                                scope.qmDisplayModel = time[0] + ":" + time[1];
                                model.setHours(time[0], time[1], 0, 0);
                                scope.$apply(function () {
                                    scope.qmModel = model;
                                });
                                setTimeout(function () {
                                    $('.clockpicker').clockpicker('hide');
                                }, 100);
                            }
                        });
                    }
                    if (attrs.hasOwnProperty("qmNoRow")) {
                        element.removeClass("row");
                        element.children(".col-xs-12").removeClass("col-xs-12");
                    }
                };
            }
            qmInputTime = __decorate([
                QMC.Directive('QMC.Input', 'qmInputTime', ['$qui'])
            ], qmInputTime);
            return qmInputTime;
        }());
        Input.qmInputTime = qmInputTime;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        var WvSelect = /** @class */ (function () {
            function WvSelect(wvService, $qui) {
                var _this = this;
                this.wvService = wvService;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmInit: '=',
                    qmWvId: '=',
                    qmSubWvId: '=',
                    qmSelectedWvId: '=',
                    qmSelectedSubWvId: '=',
                    qmLabel: '=?'
                };
                this.templateUrl = 'Input/WvSelect';
                this.link = function (scope) {
                    var storageName = "WvSelectCache_" + scope.qmWvId + "_" + scope.qmSubWvId;
                    if (!scope.qmLabel)
                        scope.qmLabel = {
                            caption: 'Bereich',
                            subCaption: 'Unterbereich'
                        };
                    else if (typeof scope.qmLabel === 'string')
                        scope.qmLabel = { caption: scope.qmLabel };
                    var init = function () {
                        var _a, _b;
                        scope.loading = true;
                        scope.subLoading = true;
                        scope.qmSelectedWvId = undefined;
                        scope.qmSelectedSubWvId = undefined;
                        var storage = sessionStorage.getItem(storageName);
                        // if cache is not set or older than five minutes, load data form server
                        if (!storage || (storage !== 'loading' && (new Date().getTime() - moment(JSON.parse(storage).timestamp).toDate().getTime() > 5 * 60 * 1000))) {
                            loadData();
                        }
                        else if (storage === 'loading') {
                            setTimeout(function () { init(); }, 500);
                        }
                        else {
                            scope.wvs = (_a = JSON.parse(storage).wvs) !== null && _a !== void 0 ? _a : [];
                            scope.subWvs = (_b = JSON.parse(storage).subWvs) !== null && _b !== void 0 ? _b : {};
                            scope.loading = false;
                            scope.subLoading = false;
                        }
                        scope.$watch('qmSelectedWvId', function () {
                            scope.qmSelectedSubWvId = null;
                            scope.subWvMap = [];
                            setTimeout(function () {
                                if (scope.subWvs && scope.qmSelectedWvId && scope.subWvs[scope.qmSelectedWvId]) {
                                    scope.subWvMap = scope.subWvs[scope.qmSelectedWvId].map(function (x) { return ({ text: x.name, value: x.objectId }); });
                                    scope.subWvMap.unshift({ text: '' });
                                }
                                _this.$qui.scopeApply(scope);
                            }, 50);
                        });
                        scope.init = true;
                    };
                    var loadData = function () {
                        sessionStorage.setItem(storageName, 'loading');
                        _this.wvService.getWvList(scope.qmWvId).then(function (data) {
                            scope.wvs = data.map(function (x) { return ({ text: x.name, value: x.objectId }); });
                            scope.wvs.unshift({ text: '' });
                            if (scope.qmSubWvId)
                                _this.wvService.getSubWvListForParent(scope.qmSubWvId, scope.qmWvId).then(function (dataSub) {
                                    scope.subWvs = dataSub;
                                }).catch(function () {
                                    scope.subWvs = {};
                                }).finally(function () {
                                    scope.subLoading = false;
                                    sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), wvs: scope.wvs, subWvs: scope.subWvs }));
                                });
                        }).catch(function () {
                            scope.wvs = [];
                        }).finally(function () {
                            scope.loading = false;
                            sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), wvs: scope.wvs, subWvs: scope.subWvs }));
                        });
                    };
                    scope.qmInit = function () {
                        init();
                    };
                    if (!scope.qmInit)
                        init();
                };
            }
            WvSelect = __decorate([
                QMC.Directive('QMC.Input', 'qmWvSelect', ['QmcWvService', '$qui'])
            ], WvSelect);
            return WvSelect;
        }());
        Input.WvSelect = WvSelect;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../maps/qmc.input.js.map
